/**
 * The applicant detail request in flight for each applicant id, shared by every
 * `useApplicantDetail` that mounts while it runs.
 */
export const applicantDetailInFlight = new Map();

/**
 * Drops shared requests that started before a change to these applicants, so a
 * component that mounts after the change fetches fresh data. No ids drops all.
 */
export function forgetApplicantDetailRequests(applicantIds) {
  if (applicantIds === undefined || applicantIds === null) {
    applicantDetailInFlight.clear();
    return;
  }
  [applicantIds].flat().forEach(id => applicantDetailInFlight.delete(id));
}
